import { useRef, useState, useEffect } from "react";
import { Loader, Modal, Panel } from "components";
// import { AxesHelper } from "three";
import { initialModels, initialScene, getMesh, getMaterials } from "helpers";
import s from "./Canvas.module.css";
// import { useWebworker } from "hooks/useWebworker";

const Canvas = ({ model, settings }) => {
    const [scene, setScene] = useState();
    const [camera, setCamera] = useState();
    const [renderer, setRenderer] = useState();
    const [isReady, setIsReady] = useState(false);

    const [showPanel, setShowPanel] = useState(false);
    // const [meshes, setMeshes] = useState();
    const [selectedMesh, setSelectedMesh] = useState(null);
    const [typeMesh, setTypeMesh] = useState();

    const canvasRef = useRef();

    useEffect(() => {
        console.log("eff1");
        const canvas = canvasRef.current;
        const { scene, camera, renderer } = initialScene(canvas);

        // const axesHelper = new AxesHelper(4);
        // scene.add(axesHelper);

        const resize = () => {
            camera.aspect = canvas.offsetWidth / canvas.offsetHeight;
            renderer.setSize(canvas.offsetWidth, canvas.offsetHeight);
            // renderer.render(scene, camera);
        };

        const selectMesh = (e) => {
            const rect = canvas.getBoundingClientRect();

            const pickPosition = {
                x: ((e.clientX - rect.left) / rect.width) * 2 - 1,
                y: ((e.clientY - rect.top) / rect.height) * -2 + 1,
            };
            const mesh = getMesh(pickPosition, scene, camera);
            console.log("mesh: ", mesh);
            if (mesh) {
                const name = mesh.name;
                if (settings.availableMeshes.includes(name)) {
                    setSelectedMesh(mesh);
                    setShowPanel(true);
                    if (name === "Floor_Grout" || name === "Floor_1") setTypeMesh("floor");
                    else if (name === "Drain") setTypeMesh("showerFloor");
                    else setTypeMesh("wall");
                }
            }
        };

        window.addEventListener("resize", resize);
        canvas.addEventListener("click", selectMesh);

        setScene(scene);
        setCamera(camera);
        setRenderer(renderer);
        setIsReady(false);

        return () => {
            window.removeEventListener("resize", resize);
        };
    }, [settings]);

    useEffect(() => {
        const loadModel = async () => {
            const { root } = await initialModels(scene, camera, model, settings);
            // setMeshes(meshes);
            scene.add(root);

            setTimeout(() => {
                renderer.render(scene, camera);
                console.log("bingo!!!!!! ");
                setIsReady(true);
            }, 50);
        };

        if (scene) {
            loadModel();
            // initialModels(scene, camera, model, settings);
            // console.log("root: ", root);

            // const promise = new Promise((res, rej) => {
            //     setTimeout(() => {
            //         renderer.render(scene, camera);
            //         console.log("bingo!!!!!! ");
            //         // setIsReady(true);
            //         res("BINGO!!!");
            //     }, 50);
            // });

            // promise.then((res) => {
            //     console.log("res: ", res);

            //     setIsReady(true);
            // });
        }
    }, [scene, camera, model, renderer, settings]);

    const cover = (options) => {
        if (selectedMesh) {
            let seamMaterial, tileMaterial;

            [seamMaterial, tileMaterial] = getMaterials(options);

            selectedMesh.material = tileMaterial;
            selectedMesh.material.needsUpdate = true; /////

            if (selectedMesh.children.length) {
                selectedMesh.children[0].material = seamMaterial;
                selectedMesh.children[0].needsUpdate = true; /////
            } else {
                const groutMesh = selectedMesh.clone();
                groutMesh.material = seamMaterial;
                groutMesh.material.needsUpdate = true; /////
                selectedMesh.add(groutMesh);
            }

            renderer.render(scene, camera);
        }
    };

    return (
        <>
            {!isReady && <Loader />}
            <canvas className={s.canvas} ref={canvasRef} />
            {showPanel && (
                <Modal close={() => setShowPanel(false)}>
                    <Panel submit={cover} typeMesh={typeMesh} />
                </Modal>
            )}
        </>
    );
};

export default Canvas;
